import { userSurveyManager } from "@core/service-container";
import React, { PropsWithChildren, useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import { Survey } from "@domain/user/user-survey";

export const SurveyRoute: React.FC<PropsWithChildren> = ({ children }) => {
	const location = useLocation();
	const dialogContext = useContext(DialogContext);

	useEffect(() => {
		const manageSurveyDialog = async (): Promise<void> => {
			await userSurveyManager.processPage(location.pathname, async (survey: Survey) => {
				dialogContext?.openModal(ModalId.AddSurvey, { survey });
			});
		};

		manageSurveyDialog();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.pathname]);

	return <>{children}</>;
};
